import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgGaruda from '../../../assets/images/pngwing.png';
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf';
import { useCallback, useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import { cekTanggalDraft, formatDateStringLocalDate } from "../../../utilities/Utils";
import imgCheckbox from '../../../assets/images/icons/checkbox_icon.png';
import imgCheckboxBlank from '../../../assets/images/icons/checkbox_blank_outline_icon.png';
import DraftAppendix from "./DraftAppendix";
import Kemasan from "../../../utilities/Kemasan";
import imgStempel from '../../../assets/images/stempel.jpg';

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingEn: {
        fontSize: 8,
        textAlign: "center",
        textDecoration: "underline"
    },
    headingIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
        marginBottom: 3
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableIdt: {
        borderLeftWidth: 1,
        borderBottom: 1,
        display: 'table',
        width: 'auto',
    },
    tableIdt2: {
        borderBottom: 1,
        display: 'table',
        width: 'auto',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableCol: {
        width: '100%',
        padding: 3,
        textAlign: 'left',
    },
    tableCol1: {
        width: '50%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol2: {
        width: '50%',
        padding: 5,
        textAlign: 'left',
    },
    tableColIdt1: {
        width: '60%',
        padding: 3,
        textAlign: 'left',
    },
    tableColIdt2: {
        width: '40%',
        padding: 3,
        textAlign: 'left',
    },
    text: {
        fontSize: 7,
        textAlign: "center",
        fontWeight: "bold",
    },
    italicText: {
        fontFamily: "Roboto-Italic",
        fontSize: 7,
        textAlign: "center",
    },
    textEn: {
        fontSize: 7,
        textAlign: "left",
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 7,
        textAlign: "left",
    },
    textBox: {
        fontSize: 8
    },
    checkicon: {
        width: 12,
        height: 12,
    },
    qrCode: {
        alignSelf: "center",
    },
    stamp: {
        alignSelf: "center",
    },
    watermark: {
        position: 'absolute',
        top: '40%',
        left: '35%',
        fontSize: 60,
        color: 'rgba(150, 150, 150, 0.3)',
        transform: 'rotate(-45deg)',
        zIndex: -1,
    },
})

const DraftH = ({ dataDisposisi, datappm, qrImage }) => {

    // console.log(datappm)

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataHc, setDataHc] = useState(null)
    const [upt, setUpt] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    const [ppmMutuArea, setPpmMutuArea] = useState(null)
    const [ppmMutuProd, setPpmMutuProd] = useState([])
    const [ppmKemasan, setPpmKemasan] = useState([])
    const [spesimenTtd, setSpesimenTtd] = useState(null)
    const [isWatermark, setIsWatermark] = useState('Y')

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const jsonMutuPK = {
                nomorAju: datappm.nomorAju,
                noProses: dataDisposisi.noTugas
            };

            const jsonPelMuat = {
                jnsPelabuhan: "D",
                kodePelabuhan: datappm.pelabuhanMuat
            };

            const jsonPelBongkar = {
                jnsPelabuhan: "L",
                kodePelabuhan: datappm.pelabuhanBongkar
            };

            const results = await Promise.allSettled([
                transaksiService.getHcMutuById(jsonMutuPK),
                userService.getUptById(datappm.kdUpt),
                masterService.getNegaraById(datappm.negaraPartner),
                masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
                masterService.getPelabuhanById(JSON.stringify(jsonPelBongkar)),
                transaksiService.listPpmDetilAll(datappm.nomorAju),
                transaksiService.listPpmKemasanAll(datappm.nomorAju),
                transaksiService.listPpmContainerAll(datappm.nomorAju),
                transaksiService.getPpmMutuById(datappm.nomorAju),
                transaksiService.listPpmMutuProdAll(datappm.nomorAju),
                transaksiService.listPpmMutuAreaAll(datappm.nomorAju)
            ])

            const [
                resHc,
                resUpt,
                resNeg,
                resPelMuat,
                resPelBongkar,
                resDetil,
                resKemasanAll,
                resKontainer,
                resMutu,
                resMutuProd,
                resMutuArea
            ] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            // Update state (batched oleh React)
            setDataHc(getData(resHc));
            setUpt(getData(resUpt, {}));
            setNegaraTujuan(getData(resNeg, {}))
            setPelMuat(getData(resPelMuat, {}));
            setPelBongkar(getData(resPelBongkar, {}));
            setPpmDetil(getData(resDetil));
            setPpmKemasan(getData(resKemasanAll));
            setPpmKontainer(getData(resKontainer));
            setPpmMutu(getData(resMutu, {}));
            setPpmMutuProd(getData(resMutuProd));
            setPpmMutuArea(getData(resMutuArea))

            const dtHc = getData(resHc)
            setIsWatermark(cekTanggalDraft(dtHc.tglHc))

            const resPegawai = await userService.getPegawaiById(resHc.value.data.nipPejabat)
            setSpesimenTtd(resPegawai.data.pathTtdImg)

        } catch (error) {
            console.error("Gagal memuat data:", error);
        }

    }, [datappm, dataDisposisi, transaksiService, masterService, userService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    // useEffect(() => {
    //     if (!datappm) return
    //     const fetchAllData = async () => {
    //         try {
    //             let jsonMutuPK = {
    //                 nomorAju: datappm.nomorAju,
    //                 noProses: dataDisposisi.noTugas
    //             }
    //             const resHc = await transaksiService.getHcMutuById(jsonMutuPK)
    //             setDataHc(resHc.data)

    //             const resUpt = await userService.getUptById(datappm.kdUpt)
    //             // console.log(resUpt)
    //             setUpt(resUpt.data)

    //             const resNeg = await masterService.getNegaraById(datappm.negaraPartner)
    //             setNegaraTujuan(resNeg.data)

    //             const jsonPelMuat = {
    //                 jnsPelabuhan: "D",
    //                 kodePelabuhan: datappm.pelabuhanMuat
    //             }
    //             const resPelDn = await masterService.getPelabuhanById(JSON.stringify(jsonPelMuat))
    //             setPelMuat(resPelDn.data)

    //             const jsonPelLn = {
    //                 jnsPelabuhan: "L",
    //                 kodePelabuhan: datappm.pelabuhanBongkar
    //             }
    //             const resPelLn = await masterService.getPelabuhanById(JSON.stringify(jsonPelLn))
    //             setPelBongkar(resPelLn.data)

    //             const resDetil = await transaksiService.listPpmDetilAll(datappm.nomorAju)
    //             setPpmDetil(resDetil.data.data)

    //             const resMutu = await transaksiService.getPpmMutuById(datappm.nomorAju)
    //             setPpmMutu(resMutu.data)

    //             const resMutuArea = await transaksiService.getPpmMutuAreaById(datappm.nomorAju)
    //             setPpmMutuArea(resMutuArea.data)

    //             const resMutuProd = await transaksiService.listPpmMutuProdAll(datappm.nomorAju)
    //             setPpmMutuProd(resMutuProd.data.data)

    //             const resKemasanAll = await transaksiService.listPpmKemasanAll(datappm.nomorAju)
    //             setPpmKemasan(resKemasanAll.data.data)

    //             const resKontainer = await transaksiService.listPpmContainerAll(datappm.nomorAju)
    //             setPpmKontainer(resKontainer.data.data)
    //         } catch (error) {
    //             // console.log(error)
    //             // setJumlahKemasan(null)
    //             // setUraianKemasan(null)
    //         }
    //     }
    //     fetchAllData()
    // }, [datappm, transaksiService, dataDisposisi, masterService, userService])

    return (
        <Document>
            <Page size="LEGAL" style={styles.page} wrap={false}>
                {
                    datappm.negaraPartner === 'PR' && isWatermark === 'Y' &&
                    <Text style={styles.watermark} fixed>D R A F T</Text>
                }
                <View>
                    <Image style={styles.headingImg} src={imgGaruda} />
                    <Text style={styles.headingEn}>THE REPUBLIC OF INDONESIA</Text>
                    <Text style={styles.headingIn}>REPUBLIK INDONESIA</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>MINISTRY OF MARINE AFFAIRS AND FISHERIES</Text>
                    <Text style={styles.headingIn}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>CERTIFICATE OF QUALITY AND SAFETY FOR FISH AND FISHERY PRODUCT</Text>
                    <Text style={styles.headingIn}>SERTIFIKAT MUTU DAN KEAMANAN HASIL PERIKANAN</Text>
                </View>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableColIdt1, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Consignor / </Text>
                                <Text style={styles.textIn}>Pengirim :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Name / </Text>
                                <Text style={styles.textIn}>Nama :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.nmPengirim : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Address / </Text>
                                <Text style={styles.textIn}>Alamat :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.alPengirim : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableColIdt2}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Reference Number </Text>
                                <Text style={styles.textIn}>Nomor Referensi: </Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableColIdt1, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Consignee / </Text>
                                <Text style={styles.textIn}>Penerima : </Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Name / </Text>
                                <Text style={styles.textIn}>Nama :</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.nmPenerima : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Address / </Text>
                                <Text style={styles.textIn}>Alamat :</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.alPenerima : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableColIdt2, { borderRightWidth: 1 }]}>
                            <View style={styles.tableIdt2}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Competent Authority / </Text>
                                    <Text style={styles.textIn}>Otoritas Kompeten: </Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                                </View>
                            </View>
                            <View style={[styles.tableIdt2, { borderBottom: 0 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Certifying Body / </Text>
                                    <Text style={styles.textIn}>Instansi Penerbit Sertifikat: </Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>{upt !== null ? upt.nmInggris : '-'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>3. Origin Country of raw Material / </Text>
                                <Text style={styles.textIn}>Negara Asal Bahan Baku :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>Indonesia</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>4. Country of Destination / </Text>
                                <Text style={styles.textIn}>Negara tujuan:</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{negaraTujuan !== null ? negaraTujuan.uraianNegara : '-'}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>5. Place of dispatch (Port) / </Text>
                                <Text style={styles.textIn}>Tempat pengeluaran (pelabuhan) :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{pelMuat !== null ? pelMuat.uraianPelabuhan : '-'}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>6. Port of destination / </Text>
                                <Text style={styles.textIn}>Pelabuhan tujuan :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{pelBongkar !== null ? pelBongkar.uraianPelabuhan : '-'}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>7. Means of transport / </Text>
                                <Text style={styles.textIn}>Alat transport : </Text>
                                {
                                    datappm.moda === '1' &&
                                    <>
                                        <Text style={styles.textEn}>Ship / </Text>
                                        <Text style={styles.textIn}>Kapal</Text>
                                    </>
                                }
                                {
                                    datappm.moda === '2' &&
                                    <>
                                        <Text style={styles.textEn}>Road Vehicle / </Text>
                                        <Text style={styles.textIn}>Angkutan Darat</Text>
                                    </>
                                }
                                {
                                    datappm.moda === '3' &&
                                    <>
                                        <Text style={styles.textEn}>Aeroplane / </Text>
                                        <Text style={styles.textIn}>Pesawat</Text>
                                    </>
                                }
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>8. Transport condition / </Text>
                                <Text style={styles.textIn}>Kondisi transportasi : </Text>
                                {
                                    ppmMutu !== null && ppmMutu !== undefined && ppmMutu.mutuTempTipe === '1' &&
                                    <>
                                        <Text style={styles.textEn}>Ambient / </Text>
                                        <Text style={styles.textIn}>Suhu Ruang</Text>
                                    </>
                                }
                                {
                                    ppmMutu !== null && ppmMutu !== undefined && ppmMutu.mutuTempTipe === '2' &&
                                    <>
                                        <Text style={styles.textEn}>Chilled / </Text>
                                        <Text style={styles.textIn}>Dingin</Text>
                                    </>
                                }
                                {
                                    ppmMutu !== null && ppmMutu !== undefined && ppmMutu.mutuTempTipe === '3' &&
                                    <>
                                        <Text style={styles.textEn}>Frozen / </Text>
                                        <Text style={styles.textIn}>Beku</Text>
                                    </>
                                }
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>9. Identification of transport / </Text>
                                <Text style={styles.textIn}>Identitas alat transportasi :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Name of transportation / </Text>
                                <Text style={styles.textIn}>Nama alat transportasi :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.nmTrans : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Transportation Number / </Text>
                                <Text style={styles.textIn}>Nomor alat transportasi :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.noFlight : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>10. Date of departure / </Text>
                                <Text style={styles.textIn}>Tanggal pengiriman :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglBerangkat) : ''}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>11. Intended uses of the product / </Text>
                                <Text style={styles.textIn}>Tujuan penggunaan product :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                {
                                    datappm.peruntukan === '1' &&
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>Human consumption / </Text>
                                        <Text style={styles.textIn}>Konsumsi manusia</Text>
                                    </View>
                                }
                                {
                                    datappm.peruntukan === '2' &&
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>Non edible / </Text>
                                        <Text style={styles.textIn}>Non pangan</Text>
                                    </View>
                                }
                                {
                                    datappm.peruntukan === '3' &&
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>Other / </Text>
                                        <Text style={styles.textIn}>Lainnya</Text>
                                    </View>
                                }
                            </View>
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>12. Source of raw material / </Text>
                                <Text style={styles.textIn}>Sumber bahan baku :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                {
                                    ppmMutuArea !== null && ppmMutuArea !== undefined && ppmMutuArea[0].mutuArea === '1' &&
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>Farm-Raised / </Text>
                                        <Text style={styles.textIn}>Budidaya</Text>
                                    </View>
                                }
                                {
                                    ppmMutuArea !== null && ppmMutuArea !== undefined && ppmMutuArea[0].mutuArea === '2' &&
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>Wild-Caught / </Text>
                                        <Text style={styles.textIn}>Tangkap</Text>
                                    </View>
                                }
                                {
                                    ppmMutuArea !== null && ppmMutuArea !== undefined && ppmMutuArea[0].mutuArea === '3' &&
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>Import / </Text>
                                        <Text style={styles.textIn}>Impor</Text>
                                    </View>
                                }
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol1, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>13. Producing Establishment / </Text>
                                <Text style={styles.textIn}>Unit Usaha :</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Name / </Text>
                                <Text style={styles.textIn}>Nama : </Text>
                                <Text style={styles.textEn}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Address / </Text>
                                <Text style={styles.textIn}>Alamat : </Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.textEn}>{dataHc !== null ? dataHc.alUpi : ''}</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Establishment identity number / </Text>
                                <Text style={styles.textIn}>Nomor Identitas unit usaha : </Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.textEn}>{dataHc !== null ? dataHc.noRegUpi : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol2, { borderRightWidth: 1 }]}>
                            <View style={styles.tableIdt2}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>14. Total Weight (kg) / </Text>
                                    <Text style={styles.textIn}>Jumlah berat (kg) :</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.netto : ''} Kgm </Text>
                                </View>
                            </View>
                            <View style={styles.tableIdt2}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>15. Total number and type of Packages / </Text>
                                    <Text style={styles.textIn}>Jumlah dan jenis kemasan : </Text>
                                </View>
                                <View style={styles.tableCol}>
                                    {/* <Text style={styles.textEn}>{jumlahKemasan !== undefined && jumlahKemasan !== null ? (<>{jumlahKemasan} {uraianKemasan}</>) : 0}</Text> */}
                                    <Text style={styles.textEn}>
                                        {
                                            ppmKemasan !== null && ppmKemasan.map((kms, idx) => {
                                                return (
                                                    <>{kms.jumlah} <Kemasan id={kms.kodeKemasan} />;</>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableIdt2, { borderBottom: 0 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>16. Container and Seal Number  / </Text>
                                    <Text style={styles.textIn}>Nomor Kontainer dan Seal : </Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>
                                        {
                                            ppmKontainer !== undefined && ppmKontainer !== null &&
                                            ppmKontainer.map((kont, index) => {
                                                return (
                                                    <>
                                                        {kont.nomor} / {kont.nomorSegel};
                                                    </>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>No.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>Products Description</Text>
                            <Text style={styles.italicText}>Deskripsi produk</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>Common and Scientific Name</Text>
                            <Text style={styles.italicText}>Nama umum dan latin</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>Quantity (kg) / (hds)</Text>
                            <Text style={styles.italicText}>Quantity (kg) / (ekor)</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>Number of packages</Text>
                            <Text style={styles.italicText}>Jumlah kemasan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>Type of packaging</Text>
                            <Text style={styles.italicText}>Jenis kemasan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>Batch number</Text>
                            <Text style={styles.italicText}>Nomor Batch</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "17%", borderRightWidth: 1 }]}>
                            <Text style={styles.text}>Date of production</Text>
                            <Text style={styles.italicText}>Tanggal produksi</Text>
                        </View>
                    </View>
                    {
                        ppmDetil.length <= 3 ?
                            (
                                ppmDetil.map((detil, index) => {
                                    return (
                                        <>
                                            <View key={index} style={[styles.tableRow]}>
                                                <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={styles.text}>{detil.trPpkDtlPK.seri}</Text>
                                                </View>
                                                {
                                                    index === 0 ?
                                                        (
                                                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                <Text style={[styles.text]}>{ppmMutu !== null && ppmMutu !== undefined && ppmMutu.mutuDesk}</Text>
                                                            </View>
                                                        ) :
                                                        (
                                                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 0 }]} />
                                                        )
                                                }
                                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={[styles.text]}>{detil.namaLokal} / </Text>
                                                    <Text style={[styles.text]}>{detil.namaLatin}</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={[styles.text]}>{detil.jumlah}</Text>
                                                </View>
                                                {
                                                    index === 0 ?
                                                        (
                                                            <>
                                                                <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                    {
                                                                        ppmKemasan.map((kms, idxKms) => {
                                                                            return (
                                                                                <>
                                                                                    <Text key={idxKms} style={[styles.text]}>{kms.jumlah}</Text>
                                                                                </>
                                                                            )
                                                                        })
                                                                    }
                                                                </View>
                                                                <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                    {
                                                                        ppmKemasan.map((kms, idxKms) => {
                                                                            return (
                                                                                <>
                                                                                    <Text key={idxKms} style={[styles.text]}>{<Kemasan id={kms.kodeKemasan} />}</Text>
                                                                                </>
                                                                            )
                                                                        })
                                                                    }
                                                                </View>
                                                                <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                    {
                                                                        ppmMutuProd.length <= 3 ?
                                                                            (
                                                                                ppmMutuProd.map((mutuProd, index) => {
                                                                                    return (
                                                                                        <Text key={index} style={[styles.text]}>
                                                                                            {mutuProd.mutuProdNo}
                                                                                        </Text>
                                                                                    )
                                                                                })
                                                                            ) :
                                                                            (
                                                                                <Text key={index} style={[styles.text]}>
                                                                                    See Appendix
                                                                                </Text>
                                                                            )
                                                                    }
                                                                    {/* {
                                                                        ppmMutuProd.map((mutuProd, index) => {
                                                                            return (
                                                                                <Text key={index} style={[styles.text]}>
                                                                                    {mutuProd.mutuProdNo}
                                                                                </Text>
                                                                            )
                                                                        })
                                                                    } */}
                                                                </View>
                                                                <View style={[styles.tableCol, { width: "17%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                    {
                                                                        ppmMutuProd.length <= 3 ?
                                                                            (
                                                                                ppmMutuProd.map((mutuProd, index) => {
                                                                                    return (
                                                                                        <Text key={index} style={[styles.text]}>
                                                                                            {mutuProd.mutuProdTgl}
                                                                                        </Text>
                                                                                    )
                                                                                })
                                                                            ) :
                                                                            (
                                                                                <Text key={index} style={[styles.text]}>
                                                                                    See Appendix
                                                                                </Text>
                                                                            )
                                                                    }
                                                                    {/* {
                                                                        ppmMutuProd.map((mutuProd, index) => {
                                                                            return (
                                                                                <Text key={index} style={[styles.text]}>
                                                                                    {mutuProd.mutuProdTgl}
                                                                                </Text>
                                                                            )
                                                                        })
                                                                    } */}
                                                                </View>
                                                            </>
                                                        ) :
                                                        (
                                                            <>
                                                                <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                                    {/* <Text style={[styles.text]}></Text> */}
                                                                </View>
                                                                <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                                    {/* <Text style={[styles.text]}></Text> */}
                                                                </View>
                                                                <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                                                                    {/* <Text style={[styles.text]}></Text> */}
                                                                </View>
                                                                <View style={[styles.tableCol, { width: "17%", borderRightWidth: 1 }]}>
                                                                    {/* <Text style={[styles.text]}></Text> */}
                                                                </View>
                                                            </>
                                                        )
                                                }
                                            </View>
                                        </>
                                    )
                                })
                            ) :
                            (
                                <>
                                    <View style={[styles.tableRow]}>
                                        <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                            <Text style={styles.text}></Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                            <Text style={[styles.text]}>See Appendix</Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                            <Text style={[styles.text]}></Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                            <Text style={[styles.text]}></Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                            <Text style={[styles.text]}></Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                            <Text style={[styles.text]}></Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                            <Text style={[styles.text]}></Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "17%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                            <Text style={[styles.text]}></Text>
                                        </View>
                                    </View>
                                </>
                            )
                    }

                </View>
                {/* <View style={[styles.tableIdt, { borderRightWidth: 1 }]}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn}>Additional Information : </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn}>This is for Additional Information</Text>
                        </View>
                    </View>
                </View> */}
                <View style={[styles.tableIdt, { borderRightWidth: 1 }]}>
                    <View style={styles.tableRow}>
                        <Text style={[styles.textEn, { fontSize: 10 }]}>Attestation / </Text>
                        <Text style={[styles.textIn, { fontSize: 10 }]}>Pernyataan</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn}>The undersigned Certifying Official certifies that the product(s) described above satisfy(s) the following requirements/ </Text>
                            <Text style={styles.textIn}>Pejabat penandatangan sertifikat di bawah ini menyatakan bahwa produk yang diuraikan di atas memenuhi persyaratan berikut :</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "1%" }]}>
                            <Image style={styles.checkicon} src={imgCheckbox} />
                        </View>
                        <View style={[styles.tableCol, { width: "3%", marginLeft: 10 }]}>
                            <Text style={styles.textEn}>a.</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn}>The Product from each batch described above have been processed, inspected and graded in (an) establishment(s) that has been approved by and under control of the Competent Authority </Text>
                            <Text style={styles.textIn}>Produk telah diproses, diinspeksi dan dinilai di unit usaha yang telah mendapat persetujuan dan dilakukan pengawasan oleh Otoritas Kompeten</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "1%" }]}>
                            {
                                ppmMutu !== null && ppmMutu !== undefined && ppmMutu.upiRegNo !== null ?
                                    <Image style={styles.checkicon} src={imgCheckbox} /> : <Image style={styles.checkicon} src={imgCheckboxBlank} />
                            }
                        </View>
                        <View style={[styles.tableCol, { width: "3%", marginLeft: 10 }]}>
                            <Text style={styles.textEn}>b.</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn}>have been handled, prepared or processed, identified, stored and transported under a competent HACCP and sanitary programme consistently implemented and in accordance with the requirements laid down in Codex Code of Practice for Fish and Fishery Products (CAC/RCP 52-2003)</Text>
                            <Text style={styles.textIn}>telah ditangani, disiapkan atau proses, diidentifikasi, disimpan dan ditransportasikan sesuai persyaratan sanitasi dan HACCP yang diterapkan secara konsisten dan sesuai dengan persyaratan yang ditetapkan Codex Code of Practice for Fish and Fishery Products. (CAC/RCP 52-2003)</Text>
                        </View>
                    </View>
                    {
                        ppmMutu !== null && ppmMutu !== undefined && ppmMutu.addInfo !== null && ppmMutu.addInfo !== '' &&
                        <>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>Additional Information : </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>{ppmMutu.addInfo}</Text>
                                </View>
                            </View>
                        </>
                    }
                </View>
                <View style={styles.tableIdt}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>QR CODE</Text>
                            </View>
                            {qrImage && (
                                <View style={styles.qrCode}>
                                    <Image src={qrImage} style={{ width: 60, height: 60 }} />
                                </View>
                            )}
                            {/* <View style={styles.tableRow}>
                                <Text style={styles.textEn}></Text>
                            </View> */}
                        </View>
                        <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>Date of Issue / </Text>
                                <Text style={styles.textIn}>Dikeluarkan tanggal : </Text>
                                <Text style={styles.textEn}>{upt !== null ? upt.kota : ''}, {dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}</Text>
                            </View>
                            {spesimenTtd && datappm.negaraPartner === 'PR' && isWatermark === 'Y' ?
                                <View style={styles.tableRow}>
                                    <View style={[styles.tableCol, { flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }]}>
                                        <View style={[styles.stamp, { marginRight: 10 }]}>
                                            <Image src={imgStempel} style={{ width: 70, height: 70 }} />
                                        </View>
                                        <View style={styles.stamp}>
                                            <Image src={spesimenTtd} style={{ width: 100, height: 60 }} />
                                        </View>
                                    </View>
                                </View>
                                :
                                <>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                        </View>
                                    </View>
                                </>
                            }
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.textEn, { textAlign: "center" }]}>Signature of the  Official Inspector</Text>
                                    <Text style={[styles.textIn, { textAlign: "center" }]}>Tanda tangan Inspektur Mutu</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.textEn, { textAlign: "center" }]}>{dataHc !== null ? dataHc.nmPejabat : ''}</Text>
                                </View>
                            </View>
                            {/* <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.textEn, { textAlign: "center" }]}>Name (capital letter)</Text>
                                    <Text style={[styles.textIn, { textAlign: "center" }]}>Nama (huruf besar)</Text>
                                </View>
                            </View> */}
                        </View>
                    </View>
                </View>
            </Page>
            {
                (ppmDetil.length > 3 || ppmMutuProd.length > 3) &&
                <>
                    <DraftAppendix ppmdetil={ppmDetil} datahc={dataHc} upt={upt} dataDisposisi={dataDisposisi} qrImage={qrImage} ppmMutuProd={ppmMutuProd} spesimenTtd={datappm.negaraPartner === 'PR' && isWatermark === 'T' ? spesimenTtd : null} finalFor="2"/>
                </>
            }
        </Document>
    )
}

export default DraftH